// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-content {
  transition: none;
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
}
.v-content[data-booted="true"] {
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.v-content__wrap {
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
}
@-moz-document url-prefix() {
@media print {
    .v-content {
      display: block;
    }
}
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_content.styl","webpack://./node_modules/vuetify/src/stylus/tools/_bootable.styl","webpack://./node_modules/vuetify/src/stylus/browsers.styl"],"names":[],"mappings":"AAGA;ECFE,gBAAY;EDKZ,aAAS;EACT,cAAM;EACN,eAAW;AAHb;ACFE;EACE,6CAAY;ADIhB;AAEE;EACE,cAAM;EACN,eAAW;EACX,kBAAU;AAAd;AEZE;AFeS;IAAA;MACL,cAAS;IACX;AACJ;AACA","sourcesContent":["@import '../bootstrap'\n@import '../browsers'\n\n.v-content\n  bootable()\n\n  display: flex\n  flex: 1 0 auto\n  max-width: 100%\n\n  &__wrap\n    flex: 1 1 auto\n    max-width: 100%\n    position: relative\n\n  +firefox()\n    @media print\n      display: block\n","bootable()\n  transition: none\n  \n  &[data-booted=\"true\"]\n    transition: .2s $transition.fast-out-slow-in\n","firefox()\n  @-moz-document url-prefix()\n    {block}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
